import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const CAT_CRACKING_RR_CONFIG = {
    type: ERFElement.CatCrackingRRBlock,
    icon: 'CatCrackingRRBlock_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Сырьё',
                    position: Position.Bottom,
                    style: { bottom: 26, left: 59, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'target_material_recycling_flow',
                    type: 'target',
                    name: 'Рециркулирующий поток',
                    position: Position.Bottom,
                    style: { bottom: 26, left: 71, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_product_flow',
                    type: 'source',
                    name: 'Продукт',
                    position: Position.Top,
                    style: { top: 6, left: 64, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_gas_flow',
                    type: 'source',
                    name: 'Выходной поток дымовых газов',
                    position: Position.Top,
                    style: { top: 15, left: 19.5, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 68, left: 7, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 68, right: 12, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFCatCrackingRRNode.config.js.map